export default "__VITE_ASSET__CJVsQuac__"